var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    { staticClass: "flex justify-between w-full" },
    [
      _c("span", [_vm._v(_vm._s(_vm.skillName))]),
      _c("SkillLabel", { attrs: { labelText: _vm.labelText } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }